import React, { useState, useEffect } from 'react';
import './CookieConsent.css';
import { initializeGTM } from '../utils/gtm';
import { config } from '../config';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    
    if (consent === 'true') {
      initializeGTM(config.gtmId);
    } else if (consent === null) {
      setIsVisible(true);
    }
    // If 'false', we do nothing and don't show banner
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    initializeGTM(config.gtmId);
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-content">
        <p>
          We use cookies to analyze traffic and improve user experience.
          By clicking "Accept", you consent to the use of all cookies.
          Separately, Cloudflare Web Analytics counts visits and page views in aggregate:
          it sets no cookies and collects nothing that identifies you, so it is always on.
        </p>
      </div>
      <div className="cookie-actions">
        <button onClick={handleDecline} className="cookie-btn decline">Decline</button>
        <button onClick={handleAccept} className="cookie-btn accept">Accept</button>
      </div>
    </div>
  );
};

export default CookieConsent;
